import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  content: {
    paddingHorizontal: 24,
    paddingBottom: 32,
    gap: 24,
  },
  header: {
    gap: 8,
  },
  title: {
    textAlign: 'center',
  },
  question: {
    marginTop: 4,
  },
  scoresContainer: {
    gap: 8,
  },
  scoresRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 6,
  },
  scoreButton: {
    width: '15%',
    aspectRatio: 1,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadius.m,
    borderWidth: 1,
    borderColor: colors.borderSubtle,
  },
  scoreButtonSelected: {
    backgroundColor: colors.backgroundBrand,
    borderColor: colors.borderBrand,
  },
  scaleLegend: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  scaleBadge: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: colors.borderSubtle,
    backgroundColor: colors.backgroundL1,
  },
  maybeLater: {
    alignItems: 'center',
    paddingVertical: 8,
  },
  feedbackContainer: {
    gap: theme.spacing[5],
    paddingVertical: 8,
  },
  checkIconWrapper: {
    alignItems: 'center',
    paddingVertical: 8,
    marginTop: theme.spacing[4],
  },
  checkIcon: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: colors.backgroundPositive,
    alignItems: 'center',
    justifyContent: 'center',
  },
  anythingElse: {
    textAlign: 'center',
    paddingBottom: theme.spacing[10],
  },
  feedbackInput: {
    height: 100,
    paddingTop: theme.spacing[3],
  },
}));
